// @ts-ignore
export default AnsiUp = new window.AnsiUp()
// export default window.AnsiUp
